import { fetchApi } from '@/config/axiosSetting.ts';
import { FileEntryQueryResponseType } from '@/modules/FileDetail/queries/fileEntry/fileEntryQuery.type.ts';

export const fileEntryQueryFunction = (
  id: string,
): Promise<FileEntryQueryResponseType> =>
  fetchApi.get(`/my_files/${id}/file_entry/`);
